<template>
  <div class="home" v-loading="loading">
    <cover :topImg="topImg"/>
    <div class="productDisplay mtb60">
      <img class="productDisplay-bg" src="@/assets/image/home/aboutUs.png"/>
      <div class="type-center">
        <div class="publicTitle">
          <div class="">产品展示</div>
          <div class="publicTitle-text">Product Display</div>
          <div class="publicTitle-line"/>
        </div>
        <div class="mt30 ml25 cl46494D productDisplay-content">
          <div>{{ $i18n.locale == 'zh' ? product.descr : product.descrEn }}</div>
          <div class="flex ju-sp mt40">
            <div class="mt15 mr40">
              <div class="line-clamp10">{{ $i18n.locale == 'zh' ? product.intro : product.introEn }}</div>
              <div class="floatRight" style="width: 167px;">
                <div class="flex ju-sp m30">
                  <img
                      class="pointer"
                      @click="productDisplayLeft(productIndex)"
                      src="@/assets/image/home/leftIcon.png">
                  <img
                      class="pointer"
                      @click="productDisplayRight(productIndex)"
                      src="@/assets/image/home/rightIcon.png">
                </div>
                <div class="bg053EB2" style="height: 5px;"/>
              </div>
              <div class="More mt60">
                <a class="cl415AEA" :href="product.link" target="_blank">{{ $t('home.查看更多') }} > ></a>
              </div>
            </div>
            <div>
              <img class="productDisplay-img" :src="$i18n.locale == 'zh'? product.image : product.imageEn"/>
              <div class="flex al-cn">
                <div class="flex al-cn ml40" v-for="(item,index) in productDisplays" :key="index">
                  <img class="productDisplay-icon mr20" src="@/assets/image/home/productDisplay-icon.png"/>
                  <div>{{ $i18n.locale == 'zh' ? item.name : item.nameEn }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="industry">
      <div class="pt25 type-center">
        <div class="publicTitle white-color">
          <div class="">行业应用</div>
          <div class="publicTitle-text">Industry Applications</div>
          <div class="publicTitle-line white-bg"/>
        </div>
        <div class="white-color mt20" style="width: 240px;" v-if="configs.iad">
          {{ $i18n.locale == 'zh' ? configs.iad.zhVal : configs.iad.enVal }}
        </div>
      </div>
      <div class="Applications" :style="{backgroundImage: `url(${applicationsImg})`}">
        <div class="Applications-list flex">
          <div
              @click="applicationsImg = $i18n.locale == 'zh' ? item.img : item.imgEn;applicationsindex=index"
              class="Applications-list-item flex ju-cn white-color"
              :style="index == applicationsindex ? 'background: rgba(255, 255, 255, 0.4)':''"
              v-for="(item, index) in industryApplications"
              :key="index">
            <div class="flex al-cn mlr10">
              <img class="icon" :src="item.icon"/>
              <div class="mlr25" style="height: 25px;border: 1px solid rgba(255,255,255,0.16);"/>
              <div class="text">{{ $i18n.locale == 'zh' ? item.title : item.titleEn }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="aboutUs mt60">
      <div class="type-center">
        <div class="publicTitle">
          <div class="">关于我们</div>
          <div class="publicTitle-text">About Us</div>
          <div class="publicTitle-line"/>
        </div>
        <div class="flex f17 cl46494D mt30">
          <img class="aboutUs-img mr60" src="@/assets/image/aboutUs.png"/>
          <div>
            <div class="mt30 f36 font-bold cl111" v-if="configs.au_cn">
              {{ $i18n.locale == 'zh' ? configs.au_cn.zhVal : configs.au_cn.enVal }}
            </div>
            <div class="bg053EB2 mt25" style="width: 51px;height: 5px"/>
            <div class="mt60 f24 font-bold cl111" v-if="configs.au_estab">
              {{ $i18n.locale == 'zh' ? configs.au_estab.zhVal : configs.au_estab.enVal }}
            </div>
            <div class="mt10 line-clamp7" v-if="configs.au_descr">
              {{ $i18n.locale == 'zh' ? configs.au_descr.zhVal : configs.au_descr.enVal }}
            </div>
            <div class="flex al-cn ju-sp mt30">
              <div>
                <div><span class="f36 font-bold cl415AEA mr5">200</span> {{ $t('home.人') }}</div>
                <div>{{ $t('home.在职员工') }}</div>
              </div>
              <div style="height: 47.5px;width: 2px;background: #C5C5C5"/>
              <div>
                <div><span class="f36 font-bold cl415AEA mr5">1.4</span> {{ $t('home.千m²') }}</div>
                <div>{{ $t('home.厂区占地面积') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt60 ourAdvantages">
      <div class="type-center grid4 white-color">
        <div class="ptb60">
          <div class="publicTitle white-color">
            <div class="">我们的优势</div>
            <div class="publicTitle-text">Our Advantages</div>
            <div class="publicTitle-line white-bg"/>
          </div>
          <div class="ourAdvantages-but pointer" @click="routerGo('/aboutUs')">{{ $t('home.联系我们') }} > ></div>
        </div>
        <div
            class="flex ju-cn ourAdvantages-list"
            :class="{'al-cn':activeCase!==index}"
            v-for="(item, index) in advantagesList"
            :key="index" @mouseenter="mouseenter(index)">
          <div v-if="activeCase===index" class="ptb60 plr30 ourAdvantages-item">
            <div class="align-center f24">{{ $i18n.locale == 'zh' ? item.title : item.titleEn }}</div>
            <div class="flex ju-cn mt5">
              <div style="width: 36px;height: 2px;background: #D8D8D8;"/>
            </div>
            <div class="mt35">{{ $i18n.locale == 'zh' ? item.descr : item.descrEn }}</div>
            <div class="serialNumber">0{{ index + 1 }}</div>
          </div>
          <div v-else class="ourAdvantages-item1">
            <div
                class="ourAdvantages-title ml10"
                style="writing-mode: vertical-rl;"
                v-if="$i18n.locale == 'zh'">
              {{ item.title }}
            </div>
            <div class="ourAdvantages-title" style="width: 100px;" v-else>{{ item.titleEn }}</div>
            <div
                :style="$i18n.locale == 'zh'?'':'margin-left: 12px'"
                class="serialNumber1">
              0{{ index + 1 }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="newsUpdates pt60">
      <div class="type-center">
        <div class="publicTitle">
          <div class="">新闻动态</div>
          <div class="publicTitle-text">News Updates</div>
          <div class="publicTitle-line"/>
        </div>
        <div class="grid2 mt30">
          <div class="newsUpdates-item mb20" v-for="(item, index) in newsList" :key="index">
            <img class="newsUpdates-item-img " :src="$i18n.locale == 'zh' ? item.thumbImg : item.thumbImgEn"/>
            <div class="flex al-cn ju-sp f16 mt30 mb10 font-bold">
              <div class="f24">{{ $i18n.locale == 'zh' ? item.title : item.titleEn }}</div>
              <div class="">{{ item.createTime }}</div>
            </div>
            <div class="line-clamp2">{{ $i18n.locale == 'zh' ? item.descr : item.descrEn }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getAdvantages, getConfigs, getIndustryApplications, getNews, getProductDisplays} from "@/api/api";

export default {
  name: "HelloWorld",
  data() {
    return {
      activeCase: 0,
      topImg: require('@/assets/image/home/topImg.png'),
      loading: false,
      configs: {}, // 配置项
      product: {}, // 产品展示
      productIndex: 0,
      productDisplays: [], // 产品展列表
      industryApplications: [], // 行业应用
      applicationsImg: '',
      applicationsindex: 0,
      newsList: [],
      advantagesList: [],
    };
  },
  created() {

  },
  mounted() {
    this.getProductDisplays()
    this.getConfigs()
    this.getIndustryApplications()
    this.getNews()
    this.getAdvantages()
  },
  methods: {
    routerGo(path){
      this.$router.push({path: path});
    },
    mouseenter(key) {
      this.activeCase = key
      // 强制重新触发动画
      this.$nextTick(() => {
        const item = document.querySelector('.ourAdvantages-item');
        if (item) {
          item.style.animation = 'none';
          setTimeout(() => {
            item.style.animation = 'slideInFromLeft 0.5s ease-in-out';
          }, 10);
        }
      });
    },
    // 产品展示左切换
    productDisplayLeft(index) {
      if (index == 0) {
        this.product = this.productDisplays[this.productDisplays.length - 1];
        this.productIndex = this.productDisplays.length - 1;
      } else {
        this.product = this.productDisplays[index - 1];
        this.productIndex = index - 1;
      }
    },
    // 产品展示右切换
    productDisplayRight(index) {
      if (index == this.productDisplays.length - 1) {
        this.product = this.productDisplays[0];
        this.productIndex = 0;
      } else {
        this.product = this.productDisplays[index + 1];
        this.productIndex = index + 1;
      }
    },
    // 获取优势列表
    getAdvantages() {
      getAdvantages().then(res => {
        if (res.code == 1) {
          if (res.data && res.data.length > 3) {
            this.advantagesList = res.data.slice(0, 3);
          } else {
            this.advantagesList = res.data || [];
          }
        }
      }).catch(err => {
      });
    },
    //新闻
    getNews() {
      getNews().then(res => {
        if (res.code == 1) {
          if (res.data && res.data.length > 2) {
            this.newsList = res.data.slice(0, 2);
          } else {
            this.newsList = res.data || [];
          }
        }
      }).catch(err => {
      });
    },
    //获取行业应用
    getIndustryApplications() {
      getIndustryApplications().then(res => {
        if (res.code == 1) {
          this.industryApplications = res.data;
          if (res.data.length) {
            this.applicationsImg = this.$i18n.locale == 'zh' ? res.data[0].img : res.data[0].imgEn;
          }
        }
      }).catch(err => {
      });
    },
    //配置信息
    getConfigs() {
      getConfigs().then(res => {
        if (res.code == 1) {
          this.configs = res.data;
          this.$store.commit('setConfigs', res.data)
        }
      }).catch(err => {
      });
    },
    // 获取产品展示
    getProductDisplays() {
      getProductDisplays().then(res => {
        if (res.code == 1) {
          this.product = res.data.length ? res.data[0] : {};
          if (res.data && res.data.length > 3) {
            this.productDisplays = res.data.slice(0, 3);
          } else {
            this.productDisplays = res.data || [];
          }
        }
      }).catch(err => {
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.home {
  font-family: PingFangSC, PingFang SC;

  .productDisplay {
    position: relative;

    &-bg {
      position: absolute;
      top: 58px;
      right: 200px;
      //width: 1171px;
      //height: 177px;
    }

    &-img {
      width: 664px;
      height: 391px;
    }

    &-icon {
      width: 16px;
      height: 16px;
    }

    &-content {
      position: relative;

      .More {
        position: absolute;
        bottom: 40px;
        left: 0;
      }
    }
  }

  .industry {
    position: relative;
    background: url("../assets/image/home/industryApplication.png") no-repeat;
    background-size: 733px 926px;
    height: 905px;

    .Applications {
      position: absolute;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      width: 1200px;
      height: 720px;
      right: 0;
      bottom: 0;

      .Applications-list {
        position: absolute;
        bottom: 0;
        left: 0;
        border-top: solid 1px #9699A0;

        .Applications-list-item {
          width: 239px;
          height: 69px;
          border-right: solid 1px #9699A0;
          //鼠标移入
          &:hover {
            cursor: pointer;
            background: rgba(255, 255, 255, 0.4);
          }
        }
      }
    }
  }

  .ourAdvantages {
    background: url("../assets/image/home/oueAdvantages.png") no-repeat;
    background-size: cover;
    height: 638px;

    &-but {
      width: 138px;
      height: 35px;
      line-height: 35px;
      background: rgba(255, 255, 255, 0.85);
      border-radius: 2px 2px 2px 2px;
      font-weight: 400;
      font-size: 18px;
      color: #1555D8;
      text-align: center;
      margin-top: 170px;
    }

    &-list {
      width: 100%;
      height: 638px;
      transition: all 0.5s ease;
    }

    &-item {
      position: relative;
      width: 300px;
      background: rgba(39, 104, 237, 0.75); //半透明背景

      //transform: translateX(-100%);
      //opacity: 0;
      transition: all 0.3s ease-in-out;

      &.slide-in {
        transform: translateX(0);
        opacity: 1;
      }
    }

    &-item1 {
      position: relative;
      height: 450px;
    }

    .serialNumber {
      position: absolute;
      bottom: 60px;
      left: 145px;
      font-weight: 400;
      font-size: 62px;
      color: #FFFFFF;
    }

    &-title {
      font-weight: 700;
      font-size: 24px;
      color: #FFFFFF;
      //max-height: 370px;
      //writing-mode: vertical-rl; // 竖排
      //text-orientation: upright; // 使所有字符（包括英文字母）都保持竖直方向
      //line-height: 1.2; // 调整行高
      //letter-spacing: 2px; // 字符间距
    }

    .serialNumber1 {
      position: absolute;
      bottom: 0;
      font-weight: 400;
      font-size: 62px;
      color: #FFFFFF;
    }
  }

  .newsUpdates {
    background: url("../assets/image/home/newsUpdatesBg.png") no-repeat;
    background-size: cover;

    &-item {
      font-size: 16px;
      color: #5E6065;

      &-img {
        width: 593px;
        height: 359px;

        &:hover {
          box-shadow: 0 2px 15px rgba(0, 0, 0, 0.5);
        }
      }

      &:hover {
        cursor: pointer;
        color: #1555D8;
      }
    }
  }
}
</style>
